<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header align-items-center d-flex">
          <h4 class="card-title mb-0 flex-grow-1">{{this.$t('page.deviceInfo')}}</h4>
        </div>
        <div class="card-body">
          <div class="row gx-3">
            <div class="col-3">
              <span class="text-danger">* </span>
              <label class="form-label">{{this.$t('page.work-order.device.name')}}</label>
            </div>
            <div class="col-1">
              <span class="must-input">* </span>
                <label class="form-label">{{this.$t('base.iot_ready')}}</label>
              </div>
          </div>
          <div class="row">
            <div class="col-3">
                  <input
                    type="text"
                    :class="[
                      'form-control',
                      ((isCheckForm && (!instance || instance.length >= 50)) ||
                        instanceError) &&
                        'is-invalid',
                    ]"
                    maxlength="50"
                    v-model="instance.instance"
                    required
                  />
                <div
                  class="must-input"
                  v-show="(isCheckForm && !instance) || instance.length >= 50"
                >
                  {{ error }}
                </div>
            </div>
            <div class="col-1">
              <el-switch
                v-model="instance.is_iot_ready"
                inline-prompt
                :active-text="this.$t('base.yes')"
                :inactive-text="this.$t('base.no')"
              />
            </div>
          </div>
          <!-- <form>
            <div class="col-3">
              <span class="must-input">* </span>
              <label class="form-label">{{this.$t('page.work-order.device.name')}}</label>
              <input
                type="text"
                :class="[
                  'form-control',
                  ((isCheckForm && (!instance || instance.length >= 50)) ||
                    instanceError) &&
                    'is-invalid',
                ]"
                maxlength="50"
                v-model="instance"
                required
              />
            </div>
           
            <div
              class="must-input"
              v-show="(isCheckForm && !instance) || instance.length >= 50"
            >
              {{ error }}
            </div>

          </form> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      instance: {},
      error: this.$t('page.device_name_cannot_be_empty'),
    };
  },
  emits: ["update:objInstance"],
  props: {
    isCheckForm: {
      type: Boolean,
      default: false,
    },
    instanceError: {
      type: Boolean,
      default: false,
    },
    objInstance: Object,
  },
  watch: {
    objInstance: {
      handler(val) {
        this.instance = val;
      },
      deep: true,
    },
    "instance": {
      handler(val) {
        if (val.instance&&val.instance.length >= 50) {
          this.error = this.$t('page.character_length_cannot_exceed_50');
        } else {
          this.error = this.$t('page.device_name_cannot_be_empty');
          this.$emit("update:objInstance", val);
        }
      },
      deep: true,
    },
  },
  methods: {},
  components: {},
};
</script>

<style scoped lang="scss"></style>
